
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15.63","height":"22","viewBox":"0 0 981 1381","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_57_13)"}},[_c('path',{attrs:{"d":"M281.039 65l625 625-625 625-146.484-146.48L613.07 690 134.555 211.484 281.039 65z","fill":"#172542"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_57_13"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h981v1381H0z"}})])])])
          )
        }
      }
    